// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_enum-bug-keys.js
// module id = 350
// module chunks = 168707334958949